<template>
  <doughnut :chartdata="chartdata" :options="options" :plugins="plugins"/>
</template>

<script>
import Doughnut from '@/components/charts/doughnut'

export default {
  name: 'PercentageOfAccounts',
  components: {
    Doughnut
  },
  props: {
    reported: {
      type: Number,
      default: () => 0
    },
    total: {
      type: Number,
      default: () => 0
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex]
              return `${dataset.data[tooltipItem.index]}% of accounts`
            }
          }
        }
      },
      plugins: [
        {
          id: 'doughnut-center-text',
          beforeDraw: function (chart) {
            var width = chart.width
            var height = chart.height
            var ctx = chart.ctx

            ctx.restore()
            var fontSize = (height / 150).toFixed(2)
            ctx.font = fontSize + 'vw Montserrat'
            ctx.textBaseline = 'middle'
            ctx.fillStyle = '#474747'

            var text = chart.data.datasets[0].data[0] + '%'
            var textX = Math.round((width - ctx.measureText(text).width) / 2)
            var textY = height / 2

            ctx.fillText(text, textX, textY)
            ctx.save()
          }
        }
      ]
    }
  },
  methods: {
    fillchartdata: function () {
      console.log()
      var success = Math.round((this.reported / this.total) * 100)
      var failed = 100 - success
      this.chartdata = {
        labels: [
          'success',
          'failed'
        ],
        datasets: [
          {
            backgroundColor: ['#06d6a0', '#ef476f'],
            data: [success, failed]
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/PercentageOfAccounts.vue